// extracted by mini-css-extract-plugin
export default {"loadingSpinnerContainer":"LoadingSpinner_loadingSpinnerContainer__2f7-9","loadingSpinner":"LoadingSpinner_loadingSpinner__QtefM","spin":"LoadingSpinner_spin__ASpdR"};